const skill_creation = [
    'Lesen/Schreiben',
    'Kunsthandwerk',
    'Fremdsprachen'
]
export default skill_creation
